// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_h4-0";
export var headerCellHover = "_h4-1";
export var readCellContainer = "_h4-2";
export var searchHighlight = "_h4-4";
export var unreadIndicator = "_h4-3";